module Client.Components.CommonButtons

open Browser.Types
open Client.Components
open Fable.FontAwesome
open Fable.React.Props
open Fable.React.Standard
open Fable.React.Helpers
open Fulma
open Fulma.Extensions.Wikiki

let onClick (f: MouseEvent -> Unit) =
    Button.OnClick(fun event ->
        event.preventDefault ()

        f event
    )

let createTooltipIconButton
    (customOptions: Button.Option list)
    (icon: Fa.IconOption)
    (toolTip: string)
    (f: MouseEvent -> Unit)
    =

    div [
        Class Tooltip.ClassName
        Tooltip.dataTooltip toolTip
    ] [
        Button.button [
            yield! customOptions

            onClick f
        ] [ Icon.createElement icon ]
    ]

let createTooltipIconLink
    (customOptions: Button.Option list)
    (icon: Fa.IconOption)
    (toolTip: string)
    (f: MouseEvent -> Unit)
    =

    div [
        Class Tooltip.ClassName
        Tooltip.dataTooltip toolTip
    ] [
        Button.a [
            yield! customOptions

            onClick f
        ] [ Icon.createElement icon ]
    ]

let createDeleteButton (customOptions: Button.Option list) =
    let buttonOptions = [ yield! customOptions; Button.Color IsDanger ]

    createTooltipIconButton buttonOptions Fa.Solid.Trash

let createFilterButton (customOptions: Button.Option list) =
    Button.button [ yield! customOptions ] [
        Icon.createElement Fa.Solid.Filter
        span [] [ str "Filter" ]
    ]